module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0116.jpg?v=83d7a609";